'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var cell = require('./cell-96115b74.js');
var cellPlaceholder = require('./cell-placeholder-3450fef5.js');
var expandIndicator = require('./expand-indicator-71da666c.js');

var TAB_SIZE = 44;
var StyledCell = styled__default(cell.Cell)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  display: ", ";\n\n  ", "\n"], ["\n  position: relative;\n  display: ", ";\n\n  ",
    "\n"])), function (_a) {
    var hidden = _a.hidden;
    return (hidden ? 'none' : 'table-cell');
}, function (_a) {
    var expandable = _a.expandable;
    return expandable && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    cursor: pointer;\n  "], ["\n    color: ", ";\n    cursor: pointer;\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.primary;
    });
});
var Container = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var CellContent = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  display: inline-block;\n  white-space: normal;\n"], ["\n  display: inline-block;\n  white-space: normal;\n"])));
var useRowClickHandler = function (row, parents, callback) { return React.useCallback(function () {
    if (row.expandable && callback) {
        callback(tslib_es6.__spread(parents, [row]));
    }
}, [callback, parents, row]); };
var ExpandableCell = function (_a) {
    var className = _a.className, row = _a.row, _b = _a.nestingLevel, nestingLevel = _b === void 0 ? 0 : _b, _c = _a.parents, parents = _c === void 0 ? [] : _c, onToggleRow = _a.onToggleRow, center = _a.center, cellIndex = _a.cellIndex, children = _a.children, hidden = _a.hidden;
    var isExpanded = !!row.childRowsExpanded || !!row.childRowsLoading;
    var handleClick = useRowClickHandler(row, parents, onToggleRow);
    var tabCount = (row.expandable || !nestingLevel) ? nestingLevel : nestingLevel + 1;
    if (cellIndex !== 0 && (row.expandable || nestingLevel >= 0)) {
        return (React__default.createElement(StyledCell, { center: center, cellIndex: cellIndex, className: className, hidden: hidden }, children));
    }
    return (React__default.createElement(StyledCell, { center: center, cellIndex: cellIndex, expandable: row.expandable, className: className, hidden: hidden, style: { paddingLeft: cell.SIDE_PADDING + TAB_SIZE * tabCount + "px" } },
        React__default.createElement(Container, null,
            React__default.createElement(expandIndicator.ExpandIndicator, { expanded: isExpanded, nestingLevel: nestingLevel }),
            React__default.createElement(cellPlaceholder.CellPlaceholder, { expandable: !!row.expandable, nestingLevel: nestingLevel, expanded: isExpanded, onClick: handleClick }),
            React__default.createElement(CellContent, null, children))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.ExpandableCell = ExpandableCell;
